import DashboardView from "../views/DashboardView.vue";
import FaqView from "../views/FaqView.vue";
import ReleasesView from "../views/ReleasesView.vue";
import CustomerDashboardView from "../views/CustomerDashboardView.vue";
import ReleaseView from "../views/ReleaseView.vue";
import AnomalyView from "../views/AnomalyView.vue";
import StatsView from "../views/StatsView.vue";
import BillingView from "../views/BillingView.vue";
import FlowsView from "../views/FlowsView.vue";
import FlowEditorView from "../views/FlowEditorView.vue";
import CustomersWizardStatusView from "../views/CustomersWizardStatusView.vue";
import CustomerWizardFlowView from "../views/CustomerWizardFlowView.vue";
import ReplacementsView from "../views/ReplacementsView.vue";
import KeywordsView from "../views/KeywordsView.vue";
import CustomersView from "../views/CustomersView.vue";
import RegionsView from "../views/RegionsView.vue";
import LogsView from "../views/LogsView.vue";
import LogDetailView from "../views/LogDetailView.vue";
import ModulesView from "../views/ModulesView.vue";
import EditModuleView from "../views/EditModuleView.vue";
import LandingPageView from "../views/LandingPageView.vue";
import NamesComponent from "../components/NamesComponent.vue";
import MissingNamesComponent from "../components/MissingNamesComponent.vue";

export default {
  title: "voice+",
  icon: "microphone",
  url: "voiceplus",
  routes: [
    {
      path: "/",
      name: "Landing",
      component: LandingPageView,
      meta: { allowedGroups: ["Developer", "Finance", "Support", "ETGL", "CX", "Imp", "billing_admin"] },
    },
    {
      path: "/customers",
      name: "Customers",
      component: CustomersView,
      meta: { allowedGroups: ["Developer", "Finance", "Support", "ETGL", "CX", "Imp"] },
    },
    {
      path: "/customers/wizardstatus",
      name: "CustomersWizardStatus",
      component: CustomersWizardStatusView,
      meta: { allowedGroups: ["Developer", "Finance", "Imp", "CX"] },
    },
    {
      path: "/customers/wizardstatus/:customerId",
      name: "CustomerWizardFlow",
      component: CustomerWizardFlowView,
      meta: { allowedGroups: ["Developer", "Finance", "Imp", "CX"] },
    },
    {
      path: "/modules",
      name: "Modules",
      component: ModulesView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/keywords",
      name: "Keywords",
      component: KeywordsView,
      meta: { allowedGroups: ["Developer", "Support", "Imp"] },
    },
    {
      path: "/regions",
      name: "Regions",
      component: RegionsView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/logs",
      name: "Logs",
      component: LogsView,
      meta: { allowedGroups: ["Developer", "Support", "ETGL"] },
    },
    {
      path: "/logs",
      name: "LogDetail",
      component: LogDetailView,
      meta: { allowedGroups: ["Developer", "Support", "ETGL"] },
    },
    {
      path: "/edit-module",
      name: "editModule",
      component: EditModuleView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/anomaly",
      name: "Anomaly",
      component: AnomalyView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/replacements",
      name: "Replacements",
      component: ReplacementsView,
      meta: { allowedGroups: ["Developer", "Support", "Imp"] },
    },
    {
      path: "/stats",
      name: "Statistics",
      component: StatsView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/billing/report",
      name: "billing_report",
      component: BillingView,
      meta: { allowedGroups: ["Developer", "Finance", "billing_admin"] },
    },
    {
      path: "/flows",
      name: "Flows",
      component: FlowsView,
      meta: { allowedGroups: ["Developer", "Imp"] },
    },
    {
      path: "/floweditor",
      name: "FlowEditor",
      component: FlowEditorView,
      meta: { allowedGroups: ["Developer", "Imp"] },
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardView,
      meta: { allowedGroups: ["Developer", "Imp"] },
    },
    {
      path: "/dashboard/:customerid",
      name: "CustomerDashboard",
      component: CustomerDashboardView,
      meta: { allowedGroups: ["Developer", "Imp"] },
    },
    {
      path: "/faq",
      name: "Faq",
      component: FaqView,
      meta: { allowedGroups: ["Developer", "Support", "Imp"] },
    },
    {
      path: "/releases/:releaseid",
      name: "Release",
      component: ReleaseView,
      meta: { allowedGroups: ["Developer", "Support", "Imp"] },
    },
    {
      path: "/releases",
      name: "Releases",
      component: ReleasesView,
      meta: { allowedGroups: ["Developer", "Support", "Imp"] },
    },
    {
      path: "/names",
      name: "Names",
      component: NamesComponent,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/stats/missing-names",
      name: "missing-names",
      component: MissingNamesComponent,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/stats/customer/outcomes",
      name: "Customer_Outcomes",
      component: () => import("@/sections/voiceplus/views/stats/BookingStats.vue"),
      meta: { allowedGroups: ["Developer", "Finance", "Imp"] },
    },
    {
      path: "/billing/legacy-report",
      name: "legacy_billing_report",
      component: () => import("@/sections/voiceplus/components/LegacyBillingComponent.vue"),
      meta: { allowedGroups: ["Developer", "Finance", "billing_admin"] },
    },
    {
      path: "/events",
      name: "events",
      component: () => import("@/sections/voiceplus/views/EventsView.vue"),
      meta: { allowedGroups: ["Developer", "Finance"] },
    },
  ],
  navbar: [
    {
      label: "Dashboard",
      icon: "chart-line",
      route: "Dashboard",
      requiredGroups: ["Developer", "Imp"],
      children: [],
    },
    {
      label: "Customers",
      icon: "users",
      route: "Customers",
      requiredGroups: ["Developer", "Finance", "Support", "ETGL", "Imp", "CX"],
      children: [],
    },
    {
      label: "Billing",
      icon: "file-invoice-dollar",
      route: "",
      requiredGroups: ["Developer", "Finance", "billing_admin"],
      children: [
        {
          label: "Report",
          icon: "file-invoice-dollar",
          route: "billing_report",
          requiredGroups: ["Developer", "Finance", "billing_admin"],
          children: [],
        },
        {
          label: "Legacy Report",
          icon: "file-invoice-dollar",
          route: "legacy_billing_report",
          requiredGroups: ["Developer", "Finance", "billing_admin"],
          children: [],
        },
      ],
    },
    {
      label: "Admin",
      icon: "lock",
      route: "",
      requiredGroups: ["Developer", "Support", "ETGL", "Imp"],
      expanded: false,
      children: [
        {
          label: "Modules",
          icon: "box-open",
          route: "Modules",
          requiredGroups: ["Developer"],
          children: [],
        },
        {
          label: "Regions",
          icon: "globe",
          route: "Regions",
          requiredGroups: ["Developer"],
          children: [],
        },
        {
          label: "Logs",
          icon: "wrench",
          route: "Logs",
          requiredGroups: ["Developer", "Support", "ETGL"],
          children: [],
        },
        {
          label: "Flows",
          icon: "robot",
          route: "Flows",
          requiredGroups: ["Developer"],
          children: [],
        },
        {
          label: "Replacements",
          icon: "shuffle",
          route: "Replacements",
          requiredGroups: ["Developer", "Support", "Imp"],
          children: [],
        },
        {
          label: "Keywords",
          icon: "key",
          route: "Keywords",
          requiredGroups: ["Developer", "Support", "Imp"],
          children: [],
        },
        {
          label: "Names",
          icon: "list-ol",
          route: "Names",
          requiredGroups: ["Developer"],
          children: [],
        },
      ],
    },
    {
      label: "Stats",
      icon: "chart-area",
      route: "",
      requiredGroups: ["Developer", "Support", "Imp", "Finance"],
      expanded: false,
      children: [
        {
          label: "Missing Names",
          icon: "signature",
          route: "missing-names",
          requiredGroups: ["Developer"],
          children: [],
        },
        {
          label: "Outcomes",
          icon: "chart-area",
          route: "Customer_Outcomes",
          requiredGroups: ["Developer"],
          children: [],
        },
      ],
    },
    {
      label: "Wizard",
      icon: "wand-magic-sparkles",
      route: "CustomersWizardStatus",
      requiredGroups: ["Developer", "Finance", "Support", "Imp", "CX"],
      children: [],
    },
    {
      label: "Events",
      icon: "circle-info",
      route: "",
      requiredGroups: ["Developer", "Finance"],
      children: [],
    },
  ],
};
